import React, { useCallback, useState } from "react";
import { updateCollection } from "../../services/firebase";
import { FIREBASE_COLLECTION_DOC_KEY, FIREBASE_COLLECTION_KEY, ROUTE_PATHS } from "../../constants";
import { useNavigate, useParams } from "react-router-dom";
import {
  getFatafatTableAddEditInitialState,
  getCurrentDayGames,
  getLastDigitOfANumber,
  sumOfDigits,
  convertTime12to24,
  nextNumericId,
  normalizeFatafat,
} from "../../util";
import "./css/style.min.css";
import "./css/matkaplay.css";
import "../common.css";
const AddFatafatResultScreen = ({ data, fatafatTableList }) => {
  const navigate = useNavigate();

  const params = useParams();

  const selectedGameIndex = params?.fatafatGuessId ?? null;
  const [{ startTime, guessNumber }, setState] = useState(
    getFatafatTableAddEditInitialState(
      getCurrentDayGames(fatafatTableList ?? []),
      selectedGameIndex
    )
  );
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  // const createFatafatTableAPICall = (body) => {
  //   APIService.post(API_CONFIGS.CREATE_FATAFAT.URL, body)
  // };
  // const updatFatafatTableAPICall = (body) => {
  //   APIService.post(API_CONFIGS.UPDATE_FATAFAT.URL, body)
  // };

  const handleAddGameSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (startTime !== "" && guessNumber !== "") {
        const stored = Array.isArray(data?.fatafatResults)
          ? data.fatafatResults
          : fatafatTableList || [];
        const winnerValue = getLastDigitOfANumber(
          sumOfDigits(parseInt(guessNumber, 10))
        ).toString();
        const gameObject = normalizeFatafat({
          startTime: convertTime12to24(startTime),
          guessNumber,
          resultValue: guessNumber,
          winnerValue,
          createdTime: new Date().toISOString(),
        });

        let fatafatResults = stored.map(normalizeFatafat);
        if (selectedGameIndex === null) {
          fatafatResults = [
            ...fatafatResults,
            normalizeFatafat({
              ...gameObject,
              fatafatGuessId: nextNumericId(fatafatResults, "fatafatGuessId"),
            }),
          ];
        } else {
          const guessId = parseInt(selectedGameIndex, 10);
          const foundIndex = fatafatResults.findIndex(
            (item) => item.fatafatGuessId === guessId
          );
          const nextRecord = normalizeFatafat({
            ...(foundIndex >= 0 ? fatafatResults[foundIndex] : {}),
            ...gameObject,
            fatafatGuessId: guessId,
            createdTime:
              foundIndex >= 0
                ? fatafatResults[foundIndex].createdTime
                : gameObject.createdTime,
          });
          if (foundIndex >= 0) {
            fatafatResults[foundIndex] = nextRecord;
          } else {
            fatafatResults.push(nextRecord);
          }
        }

        updateCollection(FIREBASE_COLLECTION_KEY, FIREBASE_COLLECTION_DOC_KEY, {
          fatafatResults,
        })
          .then(() => {
            navigate(ROUTE_PATHS.HOME);
            window.location.reload();
          })
          .catch((error) => {
            console.error("firebase fatafat save failed", error);
            alert("Could not save the fatafat result in Firebase.");
          });

      } else {
        alert("Enter all the details.");
      }
    },
    [data, fatafatTableList, navigate, guessNumber, selectedGameIndex, startTime]
  );

  return (
    <div className="login">
      <div className="container round_border_card">
        <h2 className="text-center">
          {selectedGameIndex === null
            ? "Add New Fatafat Result"
            : "Update Fatafat Result Detail"}
        </h2>
        <br />
        <form
          name="adminAddFatafatResultGame"
          validate
          onSubmit={handleAddGameSubmit}
          className="loginForm"
        >
          <div className="input-group mt-2">
            <label className="label font-weight-bold">Select Time</label>
            {data?.fatafat_result_timings &&
              data.fatafat_result_timings.map((timing, index) => {
                return (
                  <tbody key={`${timing}_${index}`}>
                    <tr>
                      <td>
                        <input
                          type="radio"
                          id="startTime"
                          name="startTime"
                          // className="mb-0"
                          required
                          value={timing}
                          checked={startTime === timing}
                          onChange={handleChange}
                        />
                        <span
                          className="font-weight-bold ml-7"
                          style={{ marginLeft: "5px" }}
                        >
                          {timing}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            {/* <input
                type="time"
                id="startTime"
                name="startTime"
                className="form-control"
                placeholder="Enter the game time*"
                required
                onChange={handleChange}
                value={startTime}
              /> */}
            <span className="error-message"></span>
          </div>

          <div className="input-group mt-2">
            <label className="label">Game Result</label>
            <input
              type="number"
              id="guessNumber"
              name="guessNumber"
              className="form-control"
              placeholder="Enter the game results*"
              maxLength={3}
              minLength={3}
              onChange={handleChange}
              value={guessNumber}
            />
            <span className="error-message"></span>
          </div>
          <br />
          <button className="button btn btn-custom btn-lg" type="submit">
            {selectedGameIndex === null ? "Add" : "Update"}
          </button>
          <button
            className="button btn btn-custom btn-lg mt-2 ml-0"
            onClick={() => navigate(ROUTE_PATHS.HOME)}
            style={{ marginTop: "10px" }}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddFatafatResultScreen;
